<template>
    <div class="page-404">
      <h1 class="page-404__code">404</h1>
      <h4 class="page-404__title">Page not found</h4>
      <p class="page-404__message text-muted">
        The page you are looking for doesn't exist or was moved.
      </p>
    </div>
  </template>
  
  <script>
  export default {
    name: "Page404",
  };
  </script>
  
  <style lang="scss" scoped>
  .page-404 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    min-height: 60vh;
    padding: 1rem;
  }
  
  .page-404__code {
    font-size: 6rem;
    font-weight: 300;
    line-height: 1;
    margin: 0 0 1rem;
  }
  
  .page-404__title {
    margin: 0 0 0.5rem;
  }
  
  .page-404__message {
    max-width: 32rem;
    margin: 0;
  }
  </style>